module.exports = __webpack_public_path__ + "img/img_11.f3532b0d.png";